<template>
  <div id="app" :class="`${lang}-lang`">
    <router-view></router-view>
  </div>
</template>

<script>import Vue from 'vue';


    import { isZh } from '@/i18n'

    
      import i18n from '@/i18n';
  const $t = i18n.t.bind(i18n);

    
export default {
  name: 'app',
  data() {
    return {
      lang: ''
    }
  },
  created() {
    this.lang = this.$ls.get('LANG')
    document.title = isZh
      ? $t('a787eaff540ed815')
      : 'Chirey International Intelligent Marketing Platform'
  }
}
</script>

<style lang="scss">
@import '~normalize.css/normalize.css'; // normalize.css 样式格式化
@import './styles/index.scss'; // 全局自定义的css样式
</style>



// WEBPACK FOOTER //
// src/App.vue